<template>
  <section class="content">
    <admin-header
      :title="'Parties'"
      :uploader="true"
      v-on:open-filter="openFilter"
      v-on:create-entity-request="goToNewEntityScreen"
      v-on:entity-quick-search="search"
      v-on:csv-upload="multiSave"
    ></admin-header>
    <div id="admin-content">
      <router-view></router-view>
    </div>
  </section>
</template>
<script>
  import AdminHeader from '../AdminHeader'
  import AdminScreenMixin from '../../mixins/AdminScreenMixin'
  export default {
    components: {AdminHeader},
    mixins: [AdminScreenMixin],
    name: 'AdminParty',
    data () {
      return {
        newEntityScreen: 'Admin - Parties',
        searchEntityScreen: 'Admin - Party search',
        filterEventName: 'admin-party-filter',
        filterName: 'PartyFilter',
        entityName: 'party'
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Party/AdminParty.vue